import { css } from 'linaria';
import { Variables } from '../foundation/global-styles';

export const infiniteScrollWrapper = css`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const infiniteScrollTrigger = css`
    height: 32px;
    width: 100%;
`;

export const infiniteScrollLoading = css`
    text-align: center;
    width: 100%;
    height: 42px;
`;

export const infiniteScrollError = css`
    position: absolute;
    top: 0;
    left: 0;
    background: ${Variables.css.alertBg};
    border: 1px solid ${Variables.css.alert};
    color: ${Variables.css.alertText};
`;
